import { useContext, useState } from "react";
import ToastContext from "../../../../context/toastProvider";
import { getSpecialPhrasePartner, updateProductStatusPartner } from "../../functions";
import { disablePartnerStatusList, getNextPartnerStatus, partnerStatusObject, statusObject } from "../../../utils/allProductStatus";
import Button from "../../../atoms/button";
import { getGradingTypeLabel, getPreLacreFormatLabel, normalizeGradingType, priorityTypes } from "../../../utils/gradingTypes";
import { cashnator, cashnatorFloat, formatarData } from "../../../utils/functions";
import LoadingOverlay from "../../../atoms/loadingOverlay";
import Modal from "../../../utils/modal";
import PartnerEditModal from "./partnerEditModal";
import { validateProductAutographNotes } from "../../../utils/serialGradeFields";


const PartnerProductInfo = ({ user, productData, refresh, stores }) => {

    const { goodToast, badToast } = useContext(ToastContext);

    const [alter, setAlter] = useState(false);
    const [edit, setEdit] = useState(false);
    const [status, setStatus] = useState(productData?.status);
    const [notify, setNotify] = useState(true);
    const [phrase, setPhrase] = useState("");
    const [loading, setLoading] = useState(false);

    const doUpdateStatus = async () => {
        setLoading(true);
        setAlter(false);
        if (status === "DONE") {
            const productSerials = Array.isArray(productData?.serials) ? productData.serials : [];
            if (productSerials.length < productData?.numberOfCards) {
                badToast("Seriais não preenchidos!");
                setLoading(false);
                return null;
            }
            const autographNotesValidation = validateProductAutographNotes({ ...productData, serials: productSerials });
            if (!autographNotesValidation.ok) {
                const messages = [];
                if (autographNotesValidation.missingCount > 0) {
                    messages.push(`${autographNotesValidation.missingCount} ${autographNotesValidation.missingCount === 1 ? "serial está sem nota de autógrafo" : "seriais estão sem nota de autógrafo"}`);
                }
                if (autographNotesValidation.invalidCount > 0) {
                    messages.push(`${autographNotesValidation.invalidCount} ${autographNotesValidation.invalidCount === 1 ? "serial tem nota de autógrafo inválida" : "seriais têm nota de autógrafo inválida"}`);
                }
                badToast(`Revise as notas de autógrafo antes de finalizar o pedido: ${messages.join(" e ")}.`);
                setLoading(false);
                return null;
            }
        }
        const data = await updateProductStatusPartner(user?.token, productData?._id, status, notify, partnerStatusObject[status], user?.email);
        if (data?.type === "success") {
            goodToast("Status do produto atualizado!");
            refresh();
        }
        if (data?.type === "error") {
            badToast(data?.message);
        }
        setLoading(false);
    }

    const doGetSpecialPhrase = async () => {
        setLoading(true);
        const data = await getSpecialPhrasePartner(user?.token, productData?._id);
        if (data?.type === "error") {
            badToast(data?.message);
            setLoading(false);
            return null;
        }
        if (data?.type === "success") {
            setPhrase(data?.data);
        }
        setLoading(false);
    }

    const openAlter = () => {
        const next = getNextPartnerStatus(productData?.status);
        if (next) {
            setStatus(next);
        }
        setAlter(true);
    }

    const closeAlter = () => {
        setStatus(productData?.status);
        setAlter(false);
    }

    return (
        <div className="m-4 border border-[#666] p-2 relative bg-monao">
            <h2 className="text-center text-lg mb-4">Detalhes do pedido</h2>
            <div className="absolute top-2 right-2 flex gap-2">
                <Button classes="bg-primary" click={() => setEdit(true)}>Editar</Button>
            </div>
            <div className="flex gap-10 w-fit m-auto flex-wrap justify-center gap-y-2">
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Tipo</p>
                    <p className="m-0 text-lg">{getGradingTypeLabel(productData?.gradingType)}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Autógrafo</p>
                    <p className="m-0 text-lg">{productData?.autographEvaluation ? "Sim" : "Não"}</p>
                </div>
                {
                    normalizeGradingType(productData?.gradingType) === "pre" && productData?.preLacreFormat ?
                        <div className="text-center w-fit max-w-[220px]">
                            <p className="m-0 text-sm text-[#999] -mb-2">Pré — lacre</p>
                            <p className="m-0 text-sm leading-tight">{getPreLacreFormatLabel(productData?.preLacreFormat)}</p>
                        </div>
                        : null
                }
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Nº de itens</p>
                    <p className="m-0 text-lg">{productData?.numberOfCards}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Prioridade</p>
                    <p className="m-0 text-lg">{priorityTypes[productData?.priority]}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Prazo</p>
                    <p className="m-0 text-lg">{productData?.deadline}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Entrega</p>
                    <p className="m-0 text-lg">{productData?.delivery}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Preço final</p>
                    <p className="m-0 text-lg">{cashnator(productData?.finalPrice)}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Valor itens</p>
                    <p className="m-0 text-lg">{cashnator(productData?.cardsValue)}</p>
                </div>
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Taxa de manuseio</p>
                    <p className="m-0 text-lg">{cashnator(productData?.insurance)}</p>
                </div>
                {
                    productData?.delivery === "correios" ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Valor frete</p>
                            <p className="m-0 text-lg">{cashnatorFloat(productData?.shipping)}</p>
                        </div>
                        : null
                }
                {
                    productData?.delivery === "correios" ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Tipo frete</p>
                            <p className="m-0 text-lg">{productData?.shippingService}</p>
                        </div>
                        : null
                }
                <div className="text-center w-fit">
                    <p className="m-0 text-sm text-[#999] -mb-2">Criado em</p>
                    <p className="m-0 text-lg">{formatarData(productData?.createdAt)}</p>
                </div>
                {
                    productData?.paidAt ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Pago em</p>
                            <p className="m-0 text-lg">{formatarData(productData?.paidAt)}</p>
                        </div>
                        : null
                }
                {
                    productData?.receivedAt ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Recebido em</p>
                            <p className="m-0 text-lg">{formatarData(productData?.receivedAt)}</p>
                        </div>
                        : null
                }
                {
                    productData?.receivedAt ?
                        <div className="text-center w-fit">
                            <p className="m-0 text-sm text-[#999] -mb-2">Data prazo</p>
                            <p className="m-0 text-lg">{formatarData(productData?.calculatedDeadline)}</p>
                        </div>
                        : null
                }
            </div>
            <div className="flex gap-2 w-fit m-auto my-4">
                <p>Status: <strong>{statusObject[productData?.status]}</strong></p>
                <div>
                    <Button classes="bg-primary" disabled={disablePartnerStatusList.includes(productData?.status)} click={openAlter}>Alterar</Button>
                </div>
            </div>

            <div>
                {
                    productData?.coupon ?
                        <div className="border border-green-700 mb-4 w-fit p-2 m-auto text-green-500 text-center">
                            <p>Cupom: <strong>{productData?.coupon?.code}</strong></p>
                            <p>Valor do desconto: <strong>{productData?.coupon?.kind === "amount" ? "R$" : null}{productData?.coupon?.value?.toFixed(2)}{productData?.coupon?.kind === "percent" ? "%" : null}</strong></p>
                        </div>
                        : null
                }
                {
                    productData?.status === "RETURNED" ?
                        <div className="flex w-fit m-auto gap-2 my-4">
                            <label></label>
                            <p className="text-center">Código de rastreio (retorno): <strong>{productData?.returnTrackingCode}</strong></p>
                        </div>
                        : null
                }
                {
                    productData?.store?._id === user?.store?._id ?
                        <p className="text-center my-4">Loja: <strong>{productData?.store?.name}</strong></p>
                        : null
                }

                <div className="flex flex-col my-4">
                    <Button classes="bg-purple-400 hover:bg-purple-600 w-1/3" click={doGetSpecialPhrase}
                        disabled={["CART", "GENERATED", "PIX", "PROCESSED", "PENDING", "APPROVED", "CANCELED"].includes(productData?.status) || phrase !== ""}>
                        Ver Frase Secreta
                    </Button>
                    <p className="p-2 font-bold text-[#d59106] text-center m-auto]">{phrase}</p>
                </div>
            </div>
            <LoadingOverlay loading={loading} />
            {
                alter ?
                    <Modal handleClose={closeAlter}>
                        <div className="relative">
                            <a className="w-10 h-10 rounded-full border border-laranjinha cursor-pointer flex items-center justify-center font-bold absolute bottom-0 right-0 text-xl bg-primary text-black" href="/partner/status" target="_blank" rel="noreferrer" title="Clique para ver a lista de status">?</a>
                            {
                                getNextPartnerStatus(productData?.status) ?
                                    <p className="text-center">O status atual do pedido é <strong className="text-green-500">{partnerStatusObject[productData?.status]}</strong>. O próximo status do fluxo seria <strong className="text-green-500">{partnerStatusObject[getNextPartnerStatus(productData?.status)]}</strong>, o qual já foi pré-selecionado na lista abaixo.</p>
                                    :
                                    <p className="text-center">O status atual do pedido é {partnerStatusObject[productData?.status]}. Este é o status final do fluxo.</p>
                            }
                            <div className="flex gap-2 w-fit m-auto my-4">

                                <p>Status: </p>
                                <select disabled={!alter} className="text-black text-center px-2" value={status} onChange={e => setStatus(e.target.value)}>
                                    {
                                        Object.keys(partnerStatusObject).map((s, i) => (
                                            <option key={i} value={s}>{partnerStatusObject[s]}</option>
                                        ))
                                    }
                                </select>

                            </div>
                            <div className="mb-4 w-fit m-auto">
                                <label className="mr-2">Notificar usuário: </label>
                                <input type="checkbox" defaultChecked={notify} onChange={() => setNotify(!notify)} />
                            </div>
                            <div className="flex gap-2 w-fit m-auto">
                                <Button classes="bg-green-500 hover:bg-green-300" disabled={status === productData?.status} click={doUpdateStatus}>Alterar</Button>
                                <Button classes="bg-red-500 hover:bg-red-300" click={closeAlter}>Cancelar</Button>
                            </div>
                        </div>
                    </Modal>
                    : null
            }
            {
                edit ?
                    <PartnerEditModal handleClose={() => setEdit(false)} stores={stores} productData={productData} refresh={refresh} />
                    : null
            }
        </div>
    )
}

export default PartnerProductInfo;
